import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogirnarbushireservice() {



  const cardData =
  {
    keyword: 'Pune to Girnar Bus Hire Service',
    heading: 'Sanavi Travels: Pune to Girnar Bus Hire Service',
    headingDescription: 'Sanavi Travels offers Pune to Girnar Bus Hire Service, providing safe, comfortable, and well-organized transportation for pilgrims, families, groups, and long-distance travelers visiting the sacred Girnar destination. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a hassle-free journey. With experienced drivers, flexible one-way and round-trip bus hire options, transparent pricing, and 24/7 booking support, we guarantee punctual and reliable travel from Pune to Girnar. Choose Sanavi Travels for trusted Pune to Girnar bus hire services, delivering comfort, safety, and convenience for a peaceful and memorable pilgrimage experience.',

    top: 'Top Places to Visit in Girnar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Girnar Hill",
    "description": "Girnar Hill, located near Junagadh in Gujarat, is one of India’s most revered pilgrimage destinations and a prominent center for both Hinduism and Jainism. Rising to a height of about 1,100 meters, the hill features hundreds of stone steps that devotees climb as an act of devotion. The trek passes through lush landscapes, ancient temples, and sacred shrines, offering a combination of spirituality, adventure, and natural beauty."
  },
  {
    "title": "Ambika Devi Temple",
    "description": "Situated at the base of Girnar Hill, Ambika Devi Temple is a sacred shrine dedicated to Goddess Ambika. The temple attracts thousands of pilgrims who come to seek blessings for prosperity, health, and spiritual growth. Its architecture, rituals, and serene surroundings make it an important starting point for the Girnar pilgrimage."
  },
  {
    "title": "Dattatreya Temple",
    "description": "Located midway up Girnar Hill, the Dattatreya Temple is dedicated to Lord Dattatreya, an incarnation embodying the trinity of Brahma, Vishnu, and Shiva. Devotees often stop here during the climb to rest and offer prayers. The temple provides panoramic views of the surrounding landscape and the city of Junagadh."
  },
  {
    "title": "Jain Temples on Girnar",
    "description": "Girnar Hill hosts a complex of ancient Jain temples, some dating back over 1,000 years. These temples are dedicated to various Tirthankaras and are known for their intricate carvings, marble architecture, and spiritual sanctity. The Neminath Temple, in particular, is a major highlight for Jain pilgrims and visitors interested in history and architecture."
  },
  {
    "title": "Girnar Ropeway (Modern Access)",
    "description": "To assist pilgrims and tourists, a ropeway has been constructed, offering a convenient and scenic ascent to some of the hill’s key temples. The ropeway provides breathtaking views of the hills, forests, and Junagadh city, making the pilgrimage accessible to all."
  },
  {
    "title": "Junagadh Panorama",
    "description": "From various points along Girnar Hill, especially near the summit, visitors can enjoy panoramic views of Junagadh city, surrounding plains, and the distant Gir forests. These vistas are particularly stunning during sunrise and sunset, adding a visual spectacle to the spiritual journey."
  },
  {
    "title": "Girnar Wildlife and Nature Trails",
    "description": "Girnar is surrounded by rich biodiversity, including forests, birds, and small wildlife. Nature enthusiasts and trekkers enjoy exploring the trails, spotting endemic species, and appreciating the serene natural environment along with the religious significance."
  },
  {
    "title": "Neminath Jain Temple",
    "description": "Neminath Temple, located near the summit of Girnar, is dedicated to Lord Neminath, the 22nd Tirthankara. This temple is a key pilgrimage site for Jains, featuring elaborate marble work, intricate sculptures, and a spiritually charged ambiance that draws devotees from across India."
  },
  {
    "title": "Cultural and Religious Significance",
    "description": "Girnar Hill holds immense religious importance for both Hindus and Jains. It represents centuries of devotion, architectural brilliance, and spiritual tradition. The pilgrimage, whether by climbing steps or taking the ropeway, is considered highly meritorious and spiritually uplifting."
  },
  {
    "title": "Festivals and Pilgrimage Events",
    "description": "Girnar hosts annual religious festivals such as the Girnar Parikrama and other temple celebrations. Devotees participate in rituals, processions, and ceremonial offerings, making these events spiritually enriching and culturally immersive. These festivals attract thousands of pilgrims and tourists alike."
  }
]
,



"services": [
{
"name": "Pune to Girnar Bus Hire Service",
"description": "Pune to Girnar Bus Hire Service offers reliable and well-organized bus transportation for devotees and travelers visiting the sacred Girnar mountain. Ideal for Jain pilgrims, families, and religious groups, this service provides comfortable seating, clean and well-maintained buses, and smooth long-distance travel. With experienced drivers and carefully planned routes, passengers can enjoy a safe, peaceful, and spiritually fulfilling journey from Pune to Girnar."
},
{
"name": "Girnar Bus Hire from Pune",
"description": "Girnar Bus Hire from Pune provides convenient and dependable bus rental solutions for religious tours and pilgrimage travel. Designed for group journeys, this service ensures timely departures, professional chauffeurs, and comfortable buses, making long-distance travel organized and stress-free."
},
{
"name": "AC Bus Pune to Girnar",
"description": "AC Bus Pune to Girnar ensures a comfortable and refreshing travel experience with fully air-conditioned buses. Suitable for long-distance journeys, senior citizens, and family travel, these buses offer relaxed seating, smooth suspension, and climate-controlled comfort throughout the pilgrimage."
},
{
"name": "Luxury Bus Girnar Darshan",
"description": "Luxury Bus Girnar Darshan delivers a premium travel experience with modern interiors, pushback seats, and enhanced onboard amenities. Ideal for VIP pilgrims, Jain groups, and special religious tours, this service combines comfort, safety, and elegance for a memorable darshan journey."
},
{
"name": "Religious Tour Bus Girnar",
"description": "Religious Tour Bus Girnar is designed specifically for devotees visiting Girnar’s sacred Jain temples. With disciplined drivers, organized travel schedules, and comfortable buses, this service ensures a peaceful and spiritually focused travel experience."
},
{
"name": "Family Girnar Trip",
"description": "Family Girnar Trip bus services are tailored for families seeking safe, comfortable, and well-organized pilgrimage travel. Spacious seating, smooth driving, and reliable scheduling ensure a pleasant journey for all age groups, making family darshan trips convenient and stress-free."
},
{
"name": "Group Travel Girnar Bus",
"description": "Group Travel Girnar Bus provides efficient transportation for large groups, Jain sanghs, and tour organizers. High-capacity buses, experienced chauffeurs, and coordinated travel planning ensure safe, comfortable, and well-managed group journeys."
},
{
"name": "Affordable Girnar Bus Rental",
"description": "Affordable Girnar Bus Rental offers budget-friendly bus rental options without compromising on safety or comfort. Ideal for devotees, families, and group travelers, this service provides transparent pricing, dependable buses, and professional drivers for economical long-distance travel."
},
{
"name": "Chauffeur Driven Bus Girnar",
"description": "Chauffeur Driven Bus Girnar ensures a hassle-free pilgrimage experience with skilled drivers managing highways, ghats, and long-distance routes. This service focuses on passenger safety, punctuality, and smooth driving for a relaxed and peaceful journey."
},
{
"name": "Best Bus Service Pune to Girnar",
"description": "Best Bus Service Pune to Girnar is known for quality buses, reliable service, and high customer satisfaction. Suitable for family pilgrimages, Jain tours, and group travel, it prioritizes comfort, safety standards, and timely arrivals."
},
{
"name": "Pune Girnar Travel Bus",
"description": "Pune Girnar Travel Bus offers organized and dependable bus travel for devotees and tourists heading to Girnar. With comfortable seating, experienced drivers, and well-planned routes, this service ensures a smooth and enjoyable long-distance journey."
},
{
"name": "Tourist Bus Girnar",
"description": "Tourist Bus Girnar caters to travelers exploring Girnar and nearby Gujarat attractions. Flexible itineraries, comfortable buses, and professional drivers make sightseeing convenient and enjoyable for tourists and travel groups."
},
{
"name": "Jain Pilgrimage Bus",
"description": "Jain Pilgrimage Bus services are dedicated to Jain devotees visiting holy sites such as Girnar. With spiritually sensitive travel arrangements, disciplined driving, and comfortable buses, this service ensures a peaceful and well-managed pilgrimage experience."
},
{
"name": "Online Bus Booking Girnar",
"description": "Online Bus Booking Girnar allows travelers to easily reserve buses with quick confirmation and flexible options. Multiple bus types, simple booking processes, and reliable service help plan Girnar pilgrimage trips efficiently and without hassle."
},
{
"name": "Gujarat Tour Bus",
"description": "Gujarat Tour Bus offers comprehensive bus travel solutions for exploring Gujarat’s religious and cultural destinations, including Girnar. With comfortable buses, experienced chauffeurs, and organized itineraries, this service ensures a memorable and spiritually enriching tour experience."
}
],
"tableData": [
["Pune to Girnar Bus Hire Service", "Girnar Bus Hire from Pune"],
["AC Bus Pune to Girnar", "Luxury Bus Girnar Darshan"],
["Religious Tour Bus Girnar", "Family Girnar Trip"],
["Group Travel Girnar Bus", "Affordable Girnar Bus Rental"],
["Chauffeur Driven Bus Girnar", "Best Bus Service Pune to Girnar"],
["Pune Girnar Travel Bus", "Tourist Bus Girnar"],
["Jain Pilgrimage Bus", "Online Bus Booking Girnar"],
["Gujarat Tour Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Girnar Bus Hire Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus hire services from Pune to Girnar, perfect for group travel, pilgrimages, family trips, and long-distance sightseeing journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable ride from Pune to Girnar."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our licensed and professional drivers are experienced with long-distance routes, ensuring safe, timely, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Girnar bus hire services, including fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated customer care team is available around the clock to assist with bookings, itinerary planning, and travel queries throughout your journey."
  },
  {
    "WhyChooseheading": "Customizable Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus hire plans tailored to your group’s schedule and travel needs for the Pune to Girnar route."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Girnar bus hire services."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services from Pune to Girnar?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus hire services from Pune to Girnar for group travel and leisure trips.'
  },
  {
    question: 'How can I book a Pune to Girnar bus?',
    answer: 'You can book the bus through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of buses are available for the Pune to Girnar route?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options based on your group size and preference.'
  },
  {
    question: 'Are the drivers experienced with long-distance travel?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes like Pune to Girnar to ensure a comfortable journey.'
  },
  {
    question: 'Can I customize the itinerary?',
    answer: 'Yes, you can customize pickup points, stops, and schedule according to your travel preferences.'
  },
  {
    question: 'Is the bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock support to help you plan and book your Pune to Girnar bus hire service.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Girnar bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Desai',
    feedback: 'Booked Pune to Girnar bus hire with Sanavi Travels — comfortable journey and excellent service. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Nair',
    feedback: 'Our trip from Pune to Girnar was seamless and enjoyable with Sanavi Travels — professional drivers and smooth ride!',
    rating: 5
  }
];


















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Girnar Bus Hire Service - Sanavi Travels",
  "description": "Sanavi Travels provides Pune to Girnar bus hire services with AC and luxury buses. Ideal for religious tours, family trips, group travel, and Jain pilgrimage. Affordable, chauffeur-driven buses with online booking available.",
  "touristType": "Family Trip, Group Travel, Religious Travel, Jain Pilgrimage, Outstation Travel",
  "departureLocation": "Pune",
  "arrivalLocation": "Girnar, Gujarat",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "22"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Girnar Bus Hire Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Girnar bus hire services by Sanavi Travels. AC and luxury buses for family trips, religious tours, group travel, and Jain pilgrimage. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/200.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogirnarbushireservice;